import styled from 'styled-components';

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 12px;
`;
